export default "__VITE_ASSET__C5NsiK2A__"